import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const PurchaseRequestPopup: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>

                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead>
                                <tr className="fw-bold  bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Grade</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Color</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Packaginng</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span>
                                            {user.orderDetail[0]?.items[0]?.grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span>
                                            {user.orderDetail[0]?.items[0]?.color || 'N/A'}
                                        </span>
                                    </td>

                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span>
                                            {user.packagingType || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>





                    <div
                        style={{
                            marginTop: '2rem',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            backgroundColor: '#ffffff',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: '#bfd7ed',
                                padding: '10px',
                                fontWeight: 600,
                                borderBottom: '1px solid #ddd',
                            }}
                        >
                            Delivery Address
                        </div>
                        <div style={{ padding: '10px', color: 'black' }}>
                            {user?.deliveryAddress}
                        </div>
                    </div>



                    <div className="table-responsive mt-8">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead>
                                <tr className="fw-bold  bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Material Picture</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Material Information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {/* {user.images?.some(img => img.docType === 'MATERIAL_DOC') ? (
                                            <div className="text-center">
                                                <img
                                                    src={user.images.find(img => img.docType === 'MATERIAL_DOC')?.docUrl}
                                                    alt="Material Picture"
                                                    className="h-150px w-150px object-cover rounded cursor-pointer"
                                                    style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                    onClick={() => window.open(
                                                        user.images.find(img => img.docType === 'MATERIAL_DOC')?.docUrl,
                                                        '_blank'
                                                    )}
                                                    onError={(e) => {
                                                        e.currentTarget.src = '/media/avatars/blank.png';
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        )} */}
                                        {user.images?.some(img => img.docType === 'MATERIAL_DOC') ? (
                                            (() => {
                                                const docUrl = user.images.find(img => img.docType === 'MATERIAL_DOC')?.docUrl;
                                                return docUrl && docUrl !== 'null' && docUrl.trim() !== '' ? (
                                                    <div className="text-center">
                                                        <i
                                                            className="bi bi-file-pdf text-danger cursor-pointer"
                                                            style={{ fontSize: '3rem' }}
                                                            onClick={() => window.open(docUrl, '_blank')}
                                                            title="View PDF"
                                                        ></i>
                                                    </div>
                                                ) : (
                                                    <span className="text-dark fw-semibold d-block fs-6">PDF not uploaded</span>
                                                );
                                            })()
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        )}
                                    </td>
                                    <td>
                                        {/* {user.images?.some(img => img.docType === 'PURCHASE_DOC') ? (
                                            <div className="text-center">
                                                <img
                                                    src={user.images.find(img => img.docType === 'PURCHASE_DOC')?.docUrl}
                                                    alt="Material Information"
                                                    className="h-150px w-150px object-cover rounded cursor-pointer"
                                                    style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                    onClick={() => window.open(
                                                        user.images.find(img => img.docType === 'PURCHASE_DOC')?.docUrl,
                                                        '_blank'
                                                    )}
                                                    onError={(e) => {
                                                        e.currentTarget.src = '/media/avatars/blank.png';
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        )} */}
                                        {user.images?.some(img => img.docType === 'PURCHASE_DOC') ? (
                                            (() => {
                                                const docUrl = user.images.find(img => img.docType === 'PURCHASE_DOC')?.docUrl;
                                                return docUrl && docUrl !== 'null' && docUrl.trim() !== '' ? (
                                                    <div className="text-center">
                                                        <i
                                                            className="bi bi-file-pdf text-danger cursor-pointer"
                                                            style={{ fontSize: '3rem' }}
                                                            onClick={() => window.open(docUrl, '_blank')}
                                                            title="View PDF"
                                                        ></i>
                                                    </div>
                                                ) : (
                                                    <span className="text-dark fw-semibold d-block fs-6">PDF not uploaded</span>
                                                );
                                            })()
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>






                    <div
                        style={{
                            marginTop: '2rem',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            backgroundColor: '#ffffff',
                            display: 'flex',
                        }}
                    >
                        <div style={{ flex: 1, borderRight: '1px solid #ddd' }}>
                            <div
                                style={{
                                    backgroundColor: '#bfd7ed',
                                    padding: '10px',
                                    fontWeight: 600,
                                    borderBottom: '1px solid #ddd',
                                }}
                            >
                                Remarks
                            </div>
                            <div style={{ padding: '10px' }}>
                                {user.remarks}
                            </div>
                        </div>

                        <div style={{ flex: 1 }}>
                            <div
                                style={{
                                    backgroundColor: '#bfd7ed',
                                    padding: '10px',
                                    fontWeight: 600,
                                    borderBottom: '1px solid #ddd',
                                }}
                            >
                                Payment Terms
                            </div>
                            <div style={{ padding: '10px' }}>
                                {user.paymentTerms}
                            </div>
                        </div>
                    </div>







                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};